/**
 * The linos or insignias a product offers in a store: those linked to the store's institution (one of their ten InstitutionID
 * slots).
 *
 * A product listed in another institution's store (the Dentistry store's dental frames, the Executive Document Frame store's
 * company wordmarks and seals) has none linked to the store's institution. It keeps its own when they all have the same first
 * institution, so the page offers what the product offers there and never mixes two schools' artwork (WEB issue 243).
 */
export const optionsForStore = <T extends {instIds?: number[]}>(options: T[], institutionID: number): T[] => {
    const linked = options.filter(option => option.instIds?.includes(institutionID));
    const first = options[0]?.instIds?.[0];
    const shared = !linked.length && first !== undefined && options.every(option => option.instIds?.[0] === first);
    return shared ? options : linked;
};
